import ripped_bottom from  '../../imgs/assets/ripped_bottom_light@2x.png';

const RasgaoBottom = () => {
  return <img src={ripped_bottom} alt="" style={{width: "100%", zIndex:"2"}} />
}

export default RasgaoBottom;